import { render, staticRenderFns } from "./MessageEncryptedBody.vue?vue&type=template&id=012512ce&scoped=true"
import script from "./MessageEncryptedBody.vue?vue&type=script&lang=js"
export * from "./MessageEncryptedBody.vue?vue&type=script&lang=js"
import style0 from "./MessageEncryptedBody.vue?vue&type=style&index=0&id=012512ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012512ce",
  null
  
)

export default component.exports